// How the till turns the menu's sections into tabs (menu consolidation, wave 2).
//
// `GET /menu/sections` carries the operator's order, down-synced from the Cloud. A section
// the back office has not placed yet (`derived`) falls back to the order a diner reads a
// menu in, then the alphabet. A section switched off in the back office is not on the till
// at all — its items are filtered out before the tabs are built.

// Mirrors `DINER_ORDER` in backend/routes/menu.py, which places unsaved sections the same way.
const CATEGORY_ORDER = [
  'starters', 'small_plates', 'sharers', 'mains', 'grill', 'burgers', 'sides', 'salads',
  'desserts', 'cheese', 'food', 'kids', 'kids_starters', 'kids_mains', 'kids_desserts',
  'drinks', 'lagers', 'wines', 'cocktails', 'shakes', 'soft_drinks', 'kids_drinks',
];

/** A comparator for category names. `sectionPos` is `{ name: position }` for placed sections. */
export const byMenuOrder = (sectionPos = {}) => (a, b) => {
  const pa = sectionPos[a];
  const pb = sectionPos[b];
  if (pa != null && pb != null) return pa - pb;
  if (pa != null) return -1;
  if (pb != null) return 1;
  const ia = CATEGORY_ORDER.indexOf(a);
  const ib = CATEGORY_ORDER.indexOf(b);
  if (ia !== -1 && ib !== -1) return ia - ib;
  if (ia !== -1) return -1;
  if (ib !== -1) return 1;
  return a.localeCompare(b);
};

/** `{ name: position }` for the sections the back office has placed (not derived). */
export const placedPositions = (sections) =>
  Object.fromEntries((sections || []).filter((s) => !s.derived).map((s) => [s.name, s.position]));

/** The items a till shows: none from a section that is switched off, and none that are off
 *  now in a section that hides its dishes while they're off (`hidden_now`, Oct 2026: the
 *  Sunday roasts on a Tuesday). An off dish in any other section shows, greyed. */
export const onTheTill = (items, sections) => {
  const off = new Set((sections || []).filter((s) => s.is_active === false).map((s) => s.name));
  if (!off.size && !items.some((it) => it.hidden_now)) return items;
  return items.filter((it) => !off.has(it.category) && !it.hidden_now);
};
